import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import rules from './rules'
import proposals from './proposals'
import competitors from './competitors'
/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::index
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:50
* @route '/pricing'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
export const calendar = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendar.url(options),
    method: 'get',
})

calendar.definition = {
    methods: ["get","head"],
    url: '/pricing/calendar',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
calendar.url = (options?: RouteQueryOptions) => {
    return calendar.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
calendar.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
calendar.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: calendar.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
const calendarForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
calendarForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::calendar
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:119
* @route '/pricing/calendar'
*/
calendarForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

calendar.form = calendarForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
export const week = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: week.url(options),
    method: 'get',
})

week.definition = {
    methods: ["get","head"],
    url: '/pricing/week',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
week.url = (options?: RouteQueryOptions) => {
    return week.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
week.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: week.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
week.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: week.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
const weekForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: week.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
weekForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: week.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::week
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:164
* @route '/pricing/week'
*/
weekForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: week.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

week.form = weekForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::toggleStopSellDate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:102
* @route '/pricing/stop-sell-date'
*/
export const toggleStopSellDate = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleStopSellDate.url(options),
    method: 'patch',
})

toggleStopSellDate.definition = {
    methods: ["patch"],
    url: '/pricing/stop-sell-date',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::toggleStopSellDate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:102
* @route '/pricing/stop-sell-date'
*/
toggleStopSellDate.url = (options?: RouteQueryOptions) => {
    return toggleStopSellDate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::toggleStopSellDate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:102
* @route '/pricing/stop-sell-date'
*/
toggleStopSellDate.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleStopSellDate.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::toggleStopSellDate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:102
* @route '/pricing/stop-sell-date'
*/
const toggleStopSellDateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleStopSellDate.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::toggleStopSellDate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:102
* @route '/pricing/stop-sell-date'
*/
toggleStopSellDateForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleStopSellDate.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

toggleStopSellDate.form = toggleStopSellDateForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::updateDay
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:190
* @route '/pricing/day'
*/
export const updateDay = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateDay.url(options),
    method: 'put',
})

updateDay.definition = {
    methods: ["put"],
    url: '/pricing/day',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::updateDay
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:190
* @route '/pricing/day'
*/
updateDay.url = (options?: RouteQueryOptions) => {
    return updateDay.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::updateDay
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:190
* @route '/pricing/day'
*/
updateDay.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateDay.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::updateDay
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:190
* @route '/pricing/day'
*/
const updateDayForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateDay.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::updateDay
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:190
* @route '/pricing/day'
*/
updateDayForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateDay.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateDay.form = updateDayForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::bulkUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:306
* @route '/pricing/bulk-update'
*/
export const bulkUpdate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkUpdate.url(options),
    method: 'post',
})

bulkUpdate.definition = {
    methods: ["post"],
    url: '/pricing/bulk-update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::bulkUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:306
* @route '/pricing/bulk-update'
*/
bulkUpdate.url = (options?: RouteQueryOptions) => {
    return bulkUpdate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::bulkUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:306
* @route '/pricing/bulk-update'
*/
bulkUpdate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkUpdate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::bulkUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:306
* @route '/pricing/bulk-update'
*/
const bulkUpdateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkUpdate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::bulkUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:306
* @route '/pricing/bulk-update'
*/
bulkUpdateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkUpdate.url(options),
    method: 'post',
})

bulkUpdate.form = bulkUpdateForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::batchUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:251
* @route '/pricing/batch-update'
*/
export const batchUpdate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batchUpdate.url(options),
    method: 'post',
})

batchUpdate.definition = {
    methods: ["post"],
    url: '/pricing/batch-update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::batchUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:251
* @route '/pricing/batch-update'
*/
batchUpdate.url = (options?: RouteQueryOptions) => {
    return batchUpdate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::batchUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:251
* @route '/pricing/batch-update'
*/
batchUpdate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batchUpdate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::batchUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:251
* @route '/pricing/batch-update'
*/
const batchUpdateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batchUpdate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::batchUpdate
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:251
* @route '/pricing/batch-update'
*/
batchUpdateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: batchUpdate.url(options),
    method: 'post',
})

batchUpdate.form = batchUpdateForm

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::reset
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:363
* @route '/pricing/reset'
*/
export const reset = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(options),
    method: 'post',
})

reset.definition = {
    methods: ["post"],
    url: '/pricing/reset',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::reset
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:363
* @route '/pricing/reset'
*/
reset.url = (options?: RouteQueryOptions) => {
    return reset.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::reset
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:363
* @route '/pricing/reset'
*/
reset.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reset.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::reset
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:363
* @route '/pricing/reset'
*/
const resetForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\PricingController::reset
* @see app/Http/Controllers/Admin/Pricing/PricingController.php:363
* @route '/pricing/reset'
*/
resetForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reset.url(options),
    method: 'post',
})

reset.form = resetForm

const pricing = {
    index: Object.assign(index, index),
    calendar: Object.assign(calendar, calendar),
    week: Object.assign(week, week),
    toggleStopSellDate: Object.assign(toggleStopSellDate, toggleStopSellDate),
    updateDay: Object.assign(updateDay, updateDay),
    bulkUpdate: Object.assign(bulkUpdate, bulkUpdate),
    batchUpdate: Object.assign(batchUpdate, batchUpdate),
    reset: Object.assign(reset, reset),
    rules: Object.assign(rules, rules),
    proposals: Object.assign(proposals, proposals),
    competitors: Object.assign(competitors, competitors),
}

export default pricing